<div style="position: relative; width: 0px; height: 0px;" *ngIf="opened">
  <div class="mat-elevation-z3 picker">
    <ng-content></ng-content>
  </div>
</div>
